import React from 'react';
import cn from 'classnames';

import styles from './validation-alert.module.scss';

export interface IValidationAlertProps {
  isFloating?: boolean;
  type?: 'danger' | 'warning' | 'information';
  children: any;
  position?: 'top' | 'bottom';
  customStyle?: boolean;
}

export default function ValidationAlert({
  isFloating = true,
  type = 'danger',
  children,
  position = 'bottom',
  customStyle = false
}: IValidationAlertProps) {
  return (
    <div
      className={cn(
        styles['validation-alert'],
        styles[`validation-alert--type-${type}`],
        {
          [styles['validation-alert--floating']]: isFloating,
          [styles['validation-alert--top']]: position === 'top',
          [styles['validation-alert--custom']]: customStyle,
        }
      )}
    >
      <div className={position === 'bottom' ? styles['content-wrapper--bottom'] : styles['content-wrapper--top']}>
        {children}
      </div>
    </div>
  );
}

export { default as ValidationAlert } from './new/ValidationAlert';
